export const positionalTitleOptions = [
  {
    label: '院士',
    value: 'ACADEMICIAN',
  },
  {
    label: '教授',
    value: 'PROFESSOR',
  },
  {
    label: '副教授',
    value: 'ASSOCIATE_PROFESSOR',
  },
  {
    label: '助理教授',
    value: 'ASSISTANT_PROFESSOR',
  },
  {
    label: '讲师',
    value: 'LECTURER',
  },
  {
    label: '研究员',
    value: 'RESEARCHER',
  },
  {
    label: '副研究员',
    value: 'ASSOCIATE_RESEARCHER',
  },
  {
    label: '助理研究员',
    value: 'FOLLOW_RESEARCHER',
  },
  {
    label: '正高级工程师',
    value: 'SENIOR_ENGINEER',
  },
];

// getLableByValue
export const getLableByValue = (value) => positionalTitleOptions.find((item) => item.value === value)?.label;
